import { createRouter } from '@tanstack/react-router'
import { rootRoute } from './routes/__root'
import { indexRoute } from './routes/index'
import { loginRoute } from './routes/login'
import { registerRoute } from './routes/register'
import { lawyerRoute } from './routes/lawyer'
import { lawyerDashboardRoute } from './routes/lawyer/dashboard'
import { lawyerBookingsRoute } from './routes/lawyer/bookings'
import { lawyerBookingDetailRoute } from './routes/lawyer/bookings/$accessId'
import { lawyerCasesRoute } from './routes/lawyer/cases'
import { lawyerCaseDetailRoute } from './routes/lawyer/cases/$caseId'
import { lawyerFlightStatusRoute } from './routes/lawyer/flight-status'
import { lawyerPricingRoute } from './routes/lawyer/pricing'
import { lawyerConsoleRoute } from './routes/lawyer/console'
import { lawyerAvailabilityRoute } from './routes/lawyer/availability'
import { lawyerSeatMapRoute } from './routes/lawyer/seatmap'
import { lawyerDebugRoute } from './routes/lawyer/debug'
import { lawyerKontakteRoute } from './routes/lawyer/kontakte'
import { lawyerKontaktDetailRoute } from './routes/lawyer/kontakte/$kontaktId'
import { clientRoute } from './routes/client'
import { caseDetailRoute } from './routes/client/case/$caseId'
import { newClaimRoute } from './routes/client/new-claim'

// Tools routes (enduser interface)
import { toolsRoute } from './routes/tools/index'
import { toolsDashboardRoute } from './routes/tools/dashboard'
import { toolsFlightStatusRoute } from './routes/tools/flight-status'
import { toolsAvailabilityRoute } from './routes/tools/availability'
import { toolsSeatmapRoute } from './routes/tools/seatmap'
import { toolsConsoleRoute } from './routes/tools/console'
import { toolsBookingsRoute } from './routes/tools/bookings'
import { toolsBookingDetailRoute } from './routes/tools/bookings/$accessId'
import { toolsPricingRoute } from './routes/tools/pricing'

// Build the route tree
// Note: caseDetailRoute is a sibling of clientRoute (not nested) so it renders independently
// Lawyer routes are nested under lawyerRoute
const lawyerRouteWithChildren = lawyerRoute.addChildren([
  lawyerDashboardRoute,
  lawyerBookingsRoute,
  lawyerBookingDetailRoute,
  lawyerPricingRoute,
  lawyerCasesRoute,
  lawyerCaseDetailRoute,
  lawyerKontakteRoute,
  lawyerKontaktDetailRoute,
  lawyerFlightStatusRoute,
  lawyerConsoleRoute,
  lawyerAvailabilityRoute,
  lawyerSeatMapRoute,
  lawyerDebugRoute,
])

// Tools routes (enduser interface)
const toolsRouteWithChildren = toolsRoute.addChildren([
  toolsDashboardRoute,
  toolsFlightStatusRoute,
  toolsAvailabilityRoute,
  toolsSeatmapRoute,
  toolsConsoleRoute,
  toolsBookingsRoute,
  toolsBookingDetailRoute,
  toolsPricingRoute,
])

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  registerRoute,
  lawyerRouteWithChildren,
  toolsRouteWithChildren,
  clientRoute,
  caseDetailRoute,
  newClaimRoute,
])

// Create and export the router
export const router = createRouter({ routeTree })

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
